import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import LogoIcon from '../../svg/LogoIcon';
import { Link } from 'gatsby';

const Header = () => (
  <header className="z-50 sticky top-0 bg-white border-b-2 border-gray-100">
    <div className="container flex flex-col sm:flex-row lg:flex justify-between items-center mx-auto py-4 px-2">
      <div className="flex w-48">
        <LogoIcon />
      </div>
      <div className="sm:space-x-1 flex mt-4 lg:space-x-5">
        <AnchorLink
          className="hidden tracking-wide px-4 text-gray-500 group inline-flex items-center space-x-2 leading-6 font-medium hover:text-blue-600 focus:outline-none focus:text-primary transition ease-in-out duration-500 lg:block"
          href="#services"
        >
          Services
        </AnchorLink>
        <AnchorLink
          className="hidden tracking-wide px-4 text-gray-500 group inline-flex items-center space-x-2 leading-6 font-medium hover:text-blue-600 focus:outline-none focus:text-primary transition ease-in-out duration-500 lg:block"
          href="#about"
        >
          About
        </AnchorLink>
        <AnchorLink
          className="hidden tracking-wide px-4 text-gray-500 group inline-flex items-center space-x-2 leading-6 font-medium hover:text-blue-600 focus:outline-none focus:text-primary transition ease-in-out duration-500 lg:block"
          href="#portfolio"
        >
          Portfolio
        </AnchorLink>
        <AnchorLink
          className="tracking-wide px-4 text-gray-500 group inline-flex items-center space-x-2 leading-6 font-medium hover:text-blue-600 focus:outline-none focus:text-primary transition ease-in-out duration-500"
          href="#blog"
        >
          Blog
        </AnchorLink>
        <Link
          to="/contact/"
          className="lg:hidden tracking-wide px-4 text-gray-500 group inline-flex items-center space-x-2 leading-6 font-medium hover:text-blue-600 focus:outline-none focus:text-primary transition ease-in-out duration-500"
          href="/contact/"
        >
          Contact
        </Link>

        <Link
          to="/marketing-terms/"
          className=" tracking-wide px-4 text-gray-500 group inline-flex items-center space-x-2 leading-6 font-medium hover:text-blue-600 focus:outline-none focus:text-primary transition ease-in-out duration-500"
          href="/contact/"
        >
          Definitions
        </Link>
      </div>

      <div className="hidden md:inline lg:block ">
        <Link to="/contact/">
          <button className="focus:outline-none bg-secondary rounded-full text-white tracking-wider inline-flex items-center px-16 py-4 border border-transparent text-sm leading-4 hover:bg-secondary-darker transition ease-in-out duration-500 ">
            Contact
          </button>
        </Link>
      </div>
    </div>
  </header>
);

export default Header;

/*<AnchorLink
          className="tracking-wide px-4 text-gray-500 group inline-flex items-center space-x-2 leading-6 font-medium hover:text-blue-600 focus:outline-none focus:text-primary transition ease-in-out duration-500"
          href="#blog"
        >
          Blog
        </AnchorLink>*/
